<section class="bg-white py-14">
  <div class="mx-auto max-w-4xl px-6">
    <div class="mb-8 flex flex-col items-center text-center">
      <p class="m-0 text-xs font-bold uppercase tracking-[0.12em] text-(--text-muted)">{{ 'pages.contact.eyebrow' | translate }}</p>
      <h1 class="m-0 mt-2 text-[28px] font-extrabold text-(--marine)">{{ 'pages.contact.title' | translate }}</h1>
    </div>

    <form class="mx-auto flex max-w-xl gap-2.5" (submit)="onSubmit($event)">
      <label for="help-search" class="sr-only">{{ 'pages.contact.searchLabel' | translate }}</label>
      <input id="help-search" type="search" [placeholder]="('pages.contact.searchLabel' | translate) + '…'" [formControl]="queryControl"
        class="box-border h-11 w-full rounded-sm border border-(--border-input) bg-white px-3.5 text-[15px] text-(--text-body) outline-none focus:border-(--brand-primary) focus:shadow-(--focus-ring)" />
      <button type="submit"
        class="box-border inline-flex h-11 shrink-0 cursor-pointer items-center justify-center rounded-sm border-0 bg-(--brand-primary) px-5 text-[14px] font-bold text-white transition-colors hover:bg-(--brand-primary-hover) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--pnud-bleu)">
        {{ 'common.search' | translate }}
      </button>
    </form>

    @if (categories().length > 0) {
      <div class="mt-5 flex flex-wrap justify-center gap-2" role="group" [attr.aria-label]="'pages.contact.filterByCategory' | translate">
        <button type="button" (click)="setCategory('')" [attr.aria-pressed]="!categoryFilter()"
          [class]="!categoryFilter()
            ? 'bg-(--pnud-bleu) text-white border-(--pnud-bleu)'
            : 'bg-white text-(--text-body) border-(--border-strong) hover:border-(--brand-primary) hover:text-(--brand-primary)'"
          class="box-border cursor-pointer rounded-full border px-4 py-1.5 text-[13px] font-bold transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--pnud-bleu)">
          {{ 'pages.documentation.allCategories' | translate }}
        </button>
        @for (category of categories(); track category.code) {
          <button type="button" (click)="setCategory(category.code)" [attr.aria-pressed]="categoryFilter() === category.code"
            [class]="categoryFilter() === category.code
              ? 'bg-(--pnud-bleu) text-white border-(--pnud-bleu)'
              : 'bg-white text-(--text-body) border-(--border-strong) hover:border-(--brand-primary) hover:text-(--brand-primary)'"
            class="box-border cursor-pointer rounded-full border px-4 py-1.5 text-[13px] font-bold transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--pnud-bleu)">
            {{ category.name }}
          </button>
        }
      </div>
    }

    @if (loading()) {
      <p class="mt-8 text-center text-[13.5px] text-(--text-muted)" aria-live="polite">{{ 'common.loading' | translate }}</p>
    } @else if (error()) {
      <p class="mt-8 text-center text-[13.5px] text-(--state-danger)" role="alert">{{ 'pages.contact.loadError' | translate }}</p>
    } @else if (sortedArticles().length > 0) {
      <div class="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        @for (article of sortedArticles(); track article.id; let i = $index) {
          <a [appScrollReveal]="i" [routerLink]="['/documentation', article.slug]"
            class="box-border block rounded-md border border-(--border-subtle) bg-white p-4.5 no-underline shadow-(--shadow-card) transition hover:-translate-y-1 hover:shadow-(--shadow-raised)">
            @if (categoryName(article.categoryCode); as name) {
              <div class="text-[11px] font-extrabold tracking-[.08em] uppercase text-(--pnud-bleu)">{{ name }}</div>
            }
            <h2 class="mt-1.5 text-[14.5px] font-bold leading-snug text-(--marine)">{{ article.title }}</h2>
            @if (article.estimatedReadMinutes) {
              <p class="mt-2 m-0 text-[12.5px] text-(--text-faint)">{{ article.estimatedReadMinutes }} {{ 'pages.documentation.readMinutesSuffix' | translate }}</p>
            }
          </a>
        } @empty {
          <p class="col-span-full m-0 text-center text-[13.5px] text-(--text-muted)">
            {{ 'pages.contact.noResults' | translate }}
          </p>
        }
      </div>
    }

    <p class="mt-8 text-center text-[13.5px] text-(--text-body)">
      {{ 'pages.contact.helpNotEnough' | translate }}
      <a href="mailto:{{ supportEmail }}" class="font-bold text-(--text-link) hover:underline">{{ 'pages.contact.contactSupport' | translate }}</a>
    </p>
  </div>
</section>
